import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { isSameOrigin } from '../backend-helpers/index.js';

const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
};
const isInsideShadowDom = (lastEl) => {
    const globalNavActiveEl = document.querySelector('main-nav global-nav')
        .shadowRoot.activeElement;
    const searchBarActiveEl = document.querySelector('main-nav search-bar')
        .shadowRoot.activeElement;
    if (globalNavActiveEl === lastEl || searchBarActiveEl === lastEl) {
        return true;
    }
    return false;
};
const handleTabKeyVisibleBtns = (e, container, tagsList, additionalElements = []) => {
    if (e.key === 'Tab') {
        const elements = container.querySelectorAll(tagsList);
        const focusable = [...elements, ...additionalElements].filter((item) => isInViewport(item));
        if (focusable === null || focusable === void 0 ? void 0 : focusable.length) {
            const first = focusable[0];
            const last = focusable.slice(-1)[0];
            const shift = e.shiftKey;
            if (shift) {
                if (e.target === first) {
                    e.preventDefault();
                }
            }
            else if (e.target === last || isInsideShadowDom(last)) {
                e.preventDefault();
            }
        }
    }
};
const handleTabKey = (e, element) => {
    const buttons = Array.from(element.querySelectorAll('generic-button[type="primary-button"]'));
    if (!buttons.length)
        return;
    const target = e.target;
    const first = buttons[0];
    const last = buttons.slice(-1)[0];
    const shift = e.shiftKey;
    if (e.key === 'Tab') {
        if (shift) {
            if (target.parentElement === first) {
                const btn = last.children[0];
                btn.focus();
                e.preventDefault();
            }
        }
        else if (target.parentElement === last) {
            const btn = first.children[0];
            btn.focus();
            e.preventDefault();
        }
    }
};
/**
 * Focuses on html input element and forces keyboard to show up (iOS Safari)
 * @param el - HTML Input Element
 * @param timeout - delay
 */
const focusAndOpenKeyboard = (el, timeout = 100) => {
    if (el) {
        // Align temp input element approximately where the input element is
        // so the cursor doesn't jump around
        const tempEl = document.createElement('input');
        tempEl.style.position = 'absolute';
        tempEl.style.opacity = '0';
        tempEl.style.top = `${el.offsetTop + 7}px`;
        tempEl.style.left = `${el.offsetLeft}px`;
        tempEl.style.height = '0px';
        document.body.appendChild(tempEl);
        tempEl.focus();
        setTimeout(() => {
            el.focus();
            el.click();
            if (typeof tempEl.remove === 'function') {
                tempEl.remove();
            }
            else {
                document.body.removeChild(tempEl);
            }
        }, timeout);
    }
};
// Allows for an element to be swipeable
const swipeElement = (element, callback, scope, onlyRight = false) => {
    let touchstartX = 0;
    let touchendX = 0;
    const handleGesture = () => {
        if (touchendX < touchstartX && !onlyRight)
            callback(scope); // swiped left
        if (touchendX > touchstartX)
            callback(scope); // swiped right
    };
    element === null || element === void 0 ? void 0 : element.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX;
    });
    element === null || element === void 0 ? void 0 : element.addEventListener('touchend', e => {
        touchendX = e.changedTouches[0].screenX;
        handleGesture();
    });
};
const scrollIntoView = (target, header, offset = 0) => {
    target.scrollIntoView();
    window.scrollTo(0, window.scrollY - (header ? header.offsetHeight : 0) - offset);
};
const setNavButtonHover = (e) => {
    const button = e.target;
    button.setAttribute('styleType', ButtonStyleTypes.DARK);
};
const unsetNavButtonHover = (e) => {
    const button = e.target;
    button.setAttribute('styleType', ButtonStyleTypes.OUTLINED_DARK);
};
const triggerExternalLinkPopup = (e, ctx) => {
    var _a, _b;
    if (!ctx.externalLinkPopup)
        return;
    let href;
    if ((_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.href) {
        href = (_b = e.currentTarget) === null || _b === void 0 ? void 0 : _b.href;
    }
    else if (ctx === null || ctx === void 0 ? void 0 : ctx.href) {
        href = ctx === null || ctx === void 0 ? void 0 : ctx.href;
    }
    if (href === 'void(0)' ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:'))
        return;
    if (!isSameOrigin(href)) {
        e.preventDefault();
        ctx.externalLinkPopup.handleClick(e, true);
    }
};
const addShowPopupEvent = (modals, popupId, button) => {
    button.addEventListener('click', () => {
        const liveModals = (modals === null || modals === void 0 ? void 0 : modals.length) > 0
            ? modals
            : Array.from(document.querySelectorAll('cvt-modal, cvt-modal-updated'));
        liveModals.forEach((modal) => {
            if (modal.popupId === popupId) {
                modal.showModal();
                const buttonEL = button.querySelector('button, a');
                if (buttonEL) {
                    /* eslint-disable no-undef */
                    globalThis.CVTModalTargetElement = buttonEL;
                    /* eslint-enable no-undef */
                }
            }
        });
    });
};
const addClosePopupEvent = (modal, button) => {
    if (modal.hideModal) {
        button.addEventListener('click', () => {
            modal.hideModal();
        });
    }
};
const closeCountrySelectorOnEscape = (modal, setFocus = false) => {
    if (modal.modalOpen)
        modal.handleModalClose(setFocus);
};
const disableBodyScroll = () => {
    document.body.style.top = `-${window.scrollY}px`;
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('with-modal');
};
const enableBodyScroll = () => {
    var _a;
    const scrolly = document.body.style.top;
    const { hash } = document.location;
    document.documentElement.style.overflow = 'auto';
    document.body.style.top = '';
    document.body.classList.remove('with-modal');
    if (hash) {
        (_a = document
            .querySelector(`[id='${hash.slice(1)}']`)) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    }
    else {
        window.scrollTo(0, Number.parseInt(scrolly || '0', 10) * -1);
    }
};
// lodash functions replacement
const debounce = (fn, ms = 300) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
};
const isEqual = (a, b) => {
    if (a === b)
        return true;
    if (a instanceof Date && b instanceof Date)
        return a.getTime() === b.getTime();
    if (!a || !b || (typeof a !== 'object' && typeof b !== 'object'))
        return a === b;
    if (a.prototype !== b.prototype)
        return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length)
        return false;
    return keys.every(k => isEqual(a[k], b[k]));
};
const throttle = (func, timeFrame) => {
    let lastTime = 0;
    return (...args) => {
        const now = new Date();
        if (+now - +lastTime >= timeFrame) {
            func(...args);
            lastTime = now;
        }
    };
};

export { addClosePopupEvent, addShowPopupEvent, closeCountrySelectorOnEscape, debounce, disableBodyScroll, enableBodyScroll, focusAndOpenKeyboard, handleTabKey, handleTabKeyVisibleBtns, isEqual, isInViewport, isInsideShadowDom, scrollIntoView, setNavButtonHover, swipeElement, throttle, triggerExternalLinkPopup, unsetNavButtonHover };
